import { BOOKING_URL } from '@/constants';

const pricingItems: {
  icon: string;
  name: string;
  subtitle: string;
  price: string;
  unit: string;
  desc: string;
  tag?: string | null;
  highlight?: boolean;
  isPromo?: boolean;
  recommended?: boolean;
}[] = [
  {
    icon: 'ri-goblet-line',
    name: 'Séance avec 3 zones',
    subtitle: 'Ventouses bambou & verre',
    price: '60',
    unit: '€',
    desc: 'Le plus demandé : 3 zones au choix pour un suivi régulier ou plusieurs points de tension.',
    tag: 'Le plus demandé',
    recommended: true,
    highlight: true,
  },
  {
    icon: 'ri-sparkling-2-line',
    name: 'Protocole Complet 5 zones',
    subtitle: 'Serviette enflammée & massage oculaire',
    price: '120',
    unit: '€',
    desc: '5 zones au choix, serviette enflammée et massage oculaire pour un soin plus complet.',
    tag: 'Holistique',
  },
  {
    icon: 'ri-run-line',
    name: 'Ventouse Récupération',
    subtitle: 'Musculaire & Sport · 1 zone',
    price: '40',
    unit: '€',
    desc: 'Protocole sportif : récupération accélérée et courbatures réduites.',
    tag: 'Sport',
  },
  {
    icon: 'ri-calendar-2-line',
    name: 'Forfait Plusieurs Séances',
    subtitle: 'Athlètes & suivi intensif',
    price: '−15',
    unit: '%',
    desc: 'Réduction sur le prix par séance pour un pack — idéal avant/après compétition.',
    tag: 'Athlètes',
    isPromo: true,
  },
];

export default function Pricing() {
  return (
    <section id="tarifs" className="py-16 px-6 bg-[#07271f] scroll-mt-[84px]">
      <div className="max-w-[1180px] mx-auto">
        <div className="max-w-[640px] mx-auto mb-10 text-center">
          <span className="text-[#8fd6b8] text-xs font-semibold tracking-widest uppercase mb-3 block">
            Transparence & accessibilité
          </span>
          <h2
            className="text-[clamp(34px,4.4vw,52px)] font-bold leading-[1.12] text-[#f7f3ea] mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Nos Tarifs
          </h2>
          <p className="text-base leading-relaxed text-[#f7f3ea]/65">
            Consultation initiale gratuite. En cas de doute, commencez par la séance 3 zones — le plus
            demandée.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          {pricingItems.map((item) => {
            if (item.isPromo) {
              return (
                <div
                  key={item.name}
                  className="bg-[#8fd6b8]/10 border border-[#8fd6b8]/45 rounded-[18px] p-[26px] flex flex-col"
                >
                  <div className="flex items-center justify-between gap-2">
                    <i className={`${item.icon} text-[#9fdcbe] text-2xl`}></i>
                    <span className="text-[10px] font-bold tracking-wider uppercase text-[#07271f] bg-[#9fdcbe] px-2.5 py-1 rounded-full">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-[16px] font-semibold text-[#f7f3ea] mt-4 mb-0.5">{item.name}</h3>
                  <div className="text-[12px] text-[#f7f3ea]/50 mb-4">{item.subtitle}</div>
                  <div
                    className="text-[40px] text-[#9fdcbe] leading-none"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {item.price}
                    <span className="text-[20px]">{item.unit}</span>
                  </div>
                  <p className="text-[13px] leading-relaxed text-[#f7f3ea]/60 my-4 flex-1">{item.desc}</p>
                  <a
                    href={BOOKING_URL}
                    className="inline-flex items-center justify-center gap-2 bg-[#9fdcbe] hover:bg-[#c9ecd9] text-[#07271f] font-bold text-sm py-3 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
                  >
                    En parler au RDV
                  </a>
                </div>
              );
            }

            return (
              <div
                key={item.name}
                className={`rounded-[18px] p-[26px] flex flex-col border ${
                  item.recommended || item.highlight
                    ? 'bg-[#8fd6b8]/10 border-[#8fd6b8]/50 ring-1 ring-[#8fd6b8]/30'
                    : 'bg-[#f2ede2]/5 border-[#8fd6b8]/20'
                }`}
              >
                <div className="flex items-center justify-between gap-2 min-h-[28px]">
                  <i className={`${item.icon} text-[#8fd6b8] text-2xl`}></i>
                  {item.tag && (
                    <span className="text-[10px] font-bold tracking-wider uppercase text-[#07271f] bg-[#9fdcbe] px-2.5 py-1 rounded-full">
                      {item.tag}
                    </span>
                  )}
                </div>
                <h3 className="text-[16px] font-semibold text-[#f7f3ea] mt-4 mb-0.5">{item.name}</h3>
                <div className="text-[12px] text-[#f7f3ea]/50 mb-4">{item.subtitle}</div>
                <div
                  className="text-[40px] text-[#9fdcbe] leading-none"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {item.price}
                  <span className="text-[20px]">{item.unit}</span>
                </div>
                <p className="text-[13px] leading-relaxed text-[#f7f3ea]/60 my-4 flex-1">{item.desc}</p>
                <a
                  href={BOOKING_URL}
                  className={`inline-flex items-center justify-center gap-2 font-semibold text-sm py-3 rounded-xl transition-colors cursor-pointer whitespace-nowrap ${
                    item.recommended
                      ? 'bg-[#0b6b52] hover:bg-[#0d7f61] text-white'
                      : 'border border-[#8fd6b8]/40 hover:bg-[#8fd6b8]/10 text-[#c9ecd9]'
                  }`}
                >
                  Demander ce soin
                </a>
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <a
            href={BOOKING_URL}
            className="inline-flex items-center gap-2.5 bg-[#0b6b52] hover:bg-[#0d7f61] text-white font-semibold text-base px-9 py-4 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calendar-check-line"></i>
            Demander un rendez-vous
          </a>
          <p className="text-xs text-[#f7f3ea]/40 mt-[18px]">
            * Tarifs indicatifs. Un devis personnalisé peut être établi lors de la consultation initiale
            gratuite.
          </p>
        </div>
      </div>
    </section>
  );
}
